/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var LocalizationKeys = /** @class */ (function () {
    function LocalizationKeys() {
    }
    LocalizationKeys.PersonalizationNameLabel = "PersonalizationNameLabel";
    LocalizationKeys.PersonalizationDialogDefaultValueLabel = "PersonalizationDialogDefaultValueLabel";
    LocalizationKeys.PersonalizationDialogDefaultValueTooltipLabel = "PersonalizationDialogDefaultValueTooltipLabel";
    LocalizationKeys.PersonalizationEntityProviderLabel = "PersonalizationEntityProviderLabel";
    LocalizationKeys.PersonalizationEntityTypeLabel = "PersonalizationEntityTypeLabel";
    LocalizationKeys.PersonalizationEntityAttributeLabel = "PersonalizationEntityAttributeLabel";
    LocalizationKeys.ErrorPersonalizationEntityProviders = "ErrorPersonalizationEntityProviders";
    LocalizationKeys.ErrorPersonalizationEntityProvidersResponseIsNull = "ErrorPersonalizationEntityProvidersResponseIsNull";
    LocalizationKeys.ErrorPersonalizationEntityType = "ErrorPersonalizationEntityType";
    LocalizationKeys.ErrorPersonalizationEntityTypeResponseIsNull = "ErrorPersonalizationEntityTypeResponseIsNull";
    LocalizationKeys.ErrorPersonalizationEntityAttribute = "ErrorPersonalizationEntityAttribute";
    LocalizationKeys.ErrorPersonalizationEntityAttributeResponseIsNull = "ErrorPersonalizationEntityAttributeResponseIsNull";
    LocalizationKeys.ErrorPersonalizationEntityAttributeIsNullInResponse = "ErrorPersonalizationEntityAttributeIsNullInResponse";
    LocalizationKeys.StringListSeparator = "StringListSeparator";
    return LocalizationKeys;
}());
export { LocalizationKeys };
